import { use, useEffect } from "react";
import Loading from "./Loading";

const Button = ({ children, title, loading = false, disabled = false, type = 'primary', size = 'medium', onClick, className, ...props }) => {
  const buttonStyles = {
    submit: 'bg-accent-main hover:bg-accent-hover text-white border border-accent-main',
    primary: 'bg-accent-main hover:bg-accent-hover text-white border border-accent-main',
    secondary: 'bg-gray-500 hover:bg-gray-600 text-white border border-gray-500',
    warning: 'bg-yellow-500 hover:bg-yellow-600 text-white border border-yellow-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white border border-red-600',
    dark: 'bg-black hover:bg-gray-800 text-white border border-black',
    primary_outline: ' bg-transparent text-accent-main border border-accent-main hover:bg-accent-main hover:text-white',
    secondary_outline: 'bg-transparent text-gray-400 border border-gray-400 hover:bg-gray-500 hover:text-white',
    warning_outline: ' bg-transparent text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white',
    danger_outline: ' bg-transparent text-red-600 border border-red-600 hover:bg-red-600 hover:text-white',
    dark_outline: ' bg-transparent text-black border border-black hover:bg-black hover:text-white',
    anchor: 'bg-transparent text-accent-main hover:bg-accent-main/10',
    small: 'min-w-2 px-2 py-1 text-sm min-w-[1px]',
    medium: 'px-4 py-2',
    large: 'px-5 py-3 text-lg',
  };

  return (
    <button
      className={`inline-flex min-w-[100px] font-sans rounded flex items-center justify-center transition duration-200 disabled:opacity-50 gap-2 ${buttonStyles[type]} ${buttonStyles[size]} ${className}`}
      type={type === 'submit' ? 'submit' : 'button'}
      title={title}
      onClick={onClick}
      disabled={loading || disabled}
      {...props}
    >
      <>
        {/* <span className="mr-1" style={{ visibility: loading ? 'visible' : 'hidden' }} > <Loading /></span>
        {children}
        <span className="ml-1" style={{ visibility: loading ? 'visible' : 'hidden' }} > <Loading /></span> */}

          {loading ? (
            <>
              <span className="invisible">{children}</span>
              <Loading className="absolute" />
            </>
            ) : (
              children
            )
          }

      </>
    </button>
  );
};

export default Button;